const airlinesData = require('../assets/data/airlinesData');

function toAirlineName (code) {
  let name = airlinesData[code];
  if (!name) return code;
  return name;
}

export default toAirlineName;